module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 57.2 57.2\"><path d=\"M1.3 55.9a4 4 0 0 0 2.8 1.2 4 4 0 0 0 2.8-1.2l21.7-21.6L50.3 56a4 4 0 0 0 5.6-5.7L34.3 28.6 56 6.9a4 4 0 0 0 0-5.7 4 4 0 0 0-5.7 0L28.6 22.9 6.9 1.3a4 4 0 0 0-5.7 0 4 4 0 0 0 0 5.7l21.7 21.6L1.3 50.3a3.87 3.87 0 0 0 0 5.6z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./static/images/close.svg
// module id = CjA4
// module chunks = 1